import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchWrapper } from '../_helpers/fetch-wrapper';
import { toast } from 'react-toastify'

// create slice

const name = 'auth';
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports

export const authActions = { ...slice.actions, ...extraActions };
export const authReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        // initialize state from local storage to enable user to stay logged in
        user: readStoredUser(),
        error: null
    }
}

export function readStoredUser() {
    try {
        const user = JSON.parse(localStorage.getItem('user'));
        const token = String(user?.token || '');
        const payloadSegment = token.split('.')[1];
        const base64 = payloadSegment.replace(/-/g, '+').replace(/_/g, '/');
        const paddedBase64 = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
        const payload = JSON.parse(atob(paddedBase64));
        const expiresAt = Number(payload.exp);
        const isExpired = Number.isFinite(expiresAt) && expiresAt > 0 && expiresAt * 1000 <= Date.now();

        if (!payload.userId || isExpired) {
            localStorage.removeItem('user');
            return null;
        }

        return user;
    } catch {
        localStorage.removeItem('user');
        return null;
    }
}

function createReducers() {
    const baseUrl = process.env.REACT_APP_URL;
    return { logout };
    function logout(state) {
        fetch(`${baseUrl}/logout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + state.user.token
            }
        })
        state.user = null;
        localStorage.removeItem('user');
    }
}

function createExtraActions() {
    const baseUrl = process.env.REACT_APP_URL;

    return {
        login: login()
    };

    function login() {
        return createAsyncThunk(
            `${name}/login`,
            async ({ email, password }) => await fetchWrapper.post(`${baseUrl}/login`, { email, password })
        );
    }
}

function createExtraReducers() {
    return (builder) => {
        login()
        // logout()
        function login() {
            var { pending, fulfilled, rejected } = extraActions.login;
            builder
                .addCase(pending, (state) => {
                    state.error = null;
                    // toast.error('Login NOT successful! ', { position: 'bottom-left' })
                })
                .addCase(fulfilled, (state, action) => {
                    const user = action.payload
                    // store user details and basic auth data in local storage to keep user logged in between page refreshes
                    localStorage.setItem('user', JSON.stringify(user));
                    state.user = user;
                })
                .addCase(rejected, (state, action) => {
                    state.error = action.error;
                    toast.error('Login failed! ' + state.error.message, { position: 'bottom-left' })
                });
        }
    }
}